"use client";

import { useScrollNearTop } from "@marketing/shared/hooks/use-scroll-near-top";
import { cn } from "@repo/ui";
import { PulseRing } from "@repo/ui/components/pulse-ring";
import { Mouse, PointerIcon } from "lucide-react";

export function LandingScrollDownHint() {
	const nearTop = useScrollNearTop();

	return (
		<div
			className={cn(
				"fixed inset-x-0 bottom-0 z-40 flex justify-center pb-6 transition-opacity duration-300",
				nearTop ? "opacity-100" : "pointer-events-none opacity-0",
			)}
			aria-hidden={!nearTop}
		>
			<div className="flex animate-pulse items-center gap-2 overflow-visible rounded-full bg-white/70 px-4 py-2 text-xs font-black uppercase tracking-wider text-slate-900 shadow-sm backdrop-blur-sm">
				<span className="relative inline-flex shrink-0 items-center justify-center overflow-visible">
					{/* PulseRing stays 44px visually but is out of flow so it never raises row height. */}
					<span
						aria-hidden
						className="pointer-events-none absolute top-1/2 left-1/2 z-0 -translate-x-1/2 -translate-y-1/2"
					>
						<span className="relative block size-[44px]">
							<PulseRing
								className="absolute inset-0"
								borderColor="rgba(99, 102, 241, 0.45)"
								borderPx={2}
								durationS={3}
								sizePx={44}
							/>
						</span>
					</span>
					<PointerIcon
						className="relative z-[1] size-3.5 shrink-0 md:hidden"
						aria-hidden
					/>
					<Mouse
						className="relative z-[1] hidden size-3.5 shrink-0 md:block"
						aria-hidden
					/>
				</span>
				SCROLL DOWN
			</div>
		</div>
	);
}
